'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const AndroidFilledIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3.96729 15.0121H19.9673V21H3.96729V15.0121Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.96729 11C3.96729 6.58172 7.54901 3 11.9673 3C16.3856 3 19.9673 6.58172 19.9673 11H3.96729ZM8.96729 10C10.0719 10 10.9673 9.10457 10.9673 8C10.9673 6.89543 10.0719 6 8.96729 6C7.86272 6 6.96729 6.89543 6.96729 8C6.96729 9.10457 7.86272 10 8.96729 10ZM14.9673 10C16.0719 10 16.9673 9.10457 16.9673 8C16.9673 6.89543 16.0719 6 14.9673 6C13.8627 6 12.9673 6.89543 12.9673 8C12.9673 9.10457 13.8627 10 14.9673 10Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3.96729 15.0121V14.2621H3.21729V15.0121H3.96729ZM19.9673 15.0121H20.7173V14.2621H19.9673V15.0121ZM19.9673 21V21.75C20.3815 21.75 20.7173 21.4142 20.7173 21H19.9673ZM3.96729 21H3.21729C3.21729 21.4142 3.55307 21.75 3.96729 21.75V21ZM3.96729 11H3.21729V11.75H3.96729V11ZM19.9673 11V11.75H20.7173V11H19.9673ZM6.71759 4.69111L4.71758 2.69106L3.65691 3.7517L5.65692 5.75176L6.71759 4.69111ZM19.1997 2.7073L17.1997 4.70731L18.2603 5.76798L20.2604 3.76797L19.1997 2.7073ZM3.96729 15.7621H19.9673V14.2621H3.96729V15.7621ZM19.2173 15.0121V21H20.7173V15.0121H19.2173ZM19.9673 20.25H3.96729V21.75H19.9673V20.25ZM4.71729 21V15.0121H3.21729V21H4.71729ZM11.9673 2.25C7.13479 2.25 3.21729 6.16751 3.21729 11H4.71729C4.71729 6.99594 7.96322 3.75 11.9673 3.75V2.25ZM20.7173 11C20.7173 6.16751 16.7998 2.25 11.9673 2.25V3.75C15.9713 3.75 19.2173 6.99594 19.2173 11H20.7173ZM3.96729 11.75H19.9673V10.25H3.96729V11.75ZM10.2173 8C10.2173 8.69036 9.65764 9.25 8.96729 9.25V10.75C10.4861 10.75 11.7173 9.51878 11.7173 8H10.2173ZM8.96729 6.75C9.65764 6.75 10.2173 7.30964 10.2173 8H11.7173C11.7173 6.48122 10.4861 5.25 8.96729 5.25V6.75ZM7.71729 8C7.71729 7.30964 8.27693 6.75 8.96729 6.75V5.25C7.4485 5.25 6.21729 6.48122 6.21729 8H7.71729ZM8.96729 9.25C8.27693 9.25 7.71729 8.69036 7.71729 8H6.21729C6.21729 9.51878 7.4485 10.75 8.96729 10.75V9.25ZM16.2173 8C16.2173 8.69036 15.6576 9.25 14.9673 9.25V10.75C16.4861 10.75 17.7173 9.51878 17.7173 8H16.2173ZM14.9673 6.75C15.6576 6.75 16.2173 7.30964 16.2173 8H17.7173C17.7173 6.48122 16.4861 5.25 14.9673 5.25V6.75ZM13.7173 8C13.7173 7.30964 14.2769 6.75 14.9673 6.75V5.25C13.4485 5.25 12.2173 6.48122 12.2173 8H13.7173ZM14.9673 9.25C14.2769 9.25 13.7173 8.69036 13.7173 8H12.2173C12.2173 9.51878 13.4485 10.75 14.9673 10.75V9.25Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const VpAndroidFilledIcon = forwardRef(AndroidFilledIcon);

export { VpAndroidFilledIcon as default };
